import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("uc-cart") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("uc-cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((x) => x.product_id === product.product_id);
      if (idx >= 0) {
        const next = [...cur];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...cur, { product_id: product.product_id, name: product.name, price: product.price, image_url: product.image_url, quantity: qty }];
    });
  };
  const remove = (product_id) => setItems((cur) => cur.filter((x) => x.product_id !== product_id));
  const setQty = (product_id, quantity) => setItems((cur) =>
    cur.map((x) => x.product_id === product_id ? { ...x, quantity: Math.max(1, quantity) } : x));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, x) => s + x.price * x.quantity, 0);
  const count = items.reduce((s, x) => s + x.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
